import React from 'react';

import { NEW_FEATURE_DATA_ATTRIBUTE } from 'app/constants';
import IconContacts from 'app/ui-kit/icons/Contacts.svg';
import IconDashboard from 'app/ui-kit/icons/Dashboard.svg';
import IconDocuments from 'app/ui-kit/icons/Documents.svg';
import IconEmail from 'app/ui-kit/icons/Email.svg';
import IconPlugins from 'app/ui-kit/icons/Plugins.svg';
import IconPrice from 'app/ui-kit/icons/Price.svg';
import IconRadar from 'app/ui-kit/icons/Radar.svg';
import IconScanner from 'app/ui-kit/icons/Scanner.svg';
import Settings from 'app/ui-kit/icons/Settings.svg';
import Webhook from 'app/ui-kit/icons/Webhook.svg';

interface Route {
    key: string;
    link: string;
    pattern?: RegExp;
    text?: string;
    icon?: React.ComponentType;
    virtual?: boolean;
    divider?: 'top' | 'bottom' | 'both';
    [NEW_FEATURE_DATA_ATTRIBUTE]?: string;
    children?: Route[];
}

export const menuRoutes: Route[] = [
    {
        key: 'search',
        link: '/search',
        text: 'Database',
        icon: IconDashboard,
        children: [
            {
                key: 'search_vendors',
                link: '/search/vendors',
                text: 'Vendors',
                pattern: new RegExp('/search/vendors.*')
            },
            {
                key: 'search_products',
                link: '/search/products',
                text: 'Products',
                pattern: new RegExp('/search/products.*')
            },
            {
                key: 'search_by_years',
                link: '/search/years',
                text: 'Timeline',
                pattern: new RegExp('/search/years.*')
            },
            {
                key: 'search_by_cvss',
                link: '/search/cvss',
                text: 'Vulnerabilities',
                pattern: new RegExp('/search/cvss.*')
            }
        ]
    },
    {
        key: 'vscanner',
        link: '/vscanner',
        text: 'Perimeter Scanner',
        icon: IconScanner,
        children: [
            {
                key: 'vscanner_scan',
                link: '/vscanner/scan',
                text: 'Scanning'
            },
            {
                key: 'vscanner_dashboard_hosts',
                link: '/vscanner/hosts',
                virtual: true
            },
            {
                key: 'vscanner_dashboard_network',
                link: '/vscanner/network',
                virtual: true
            },
            {
                key: 'vscanner_dashboard_web',
                link: '/vscanner/web',
                virtual: true
            },
            {
                key: 'vscanner_projects',
                link: '/vscanner/projects',
                text: 'Projects'
            }
        ]
    },
    {
        key: 'scanner',
        link: '/scanner',
        text: 'Scanner',
        icon: IconRadar,
        children: [
            {
                key: 'scanner_scan',
                link: '/scanner/scan',
                text: 'Agent Scanning'
            },
            {
                key: 'scanner_api-scan',
                link: '/scanner/apiscan',
                text: 'API Scanning'
            },
            {
                key: 'scanner_audit',
                link: '/scanner/audit',
                text: 'Manual Audit'
            }
        ]
    },
    {
        key: 'email',
        link: '/email',
        text: 'Email',
        icon: IconEmail
    },
    {
        key: 'webhook',
        link: '/webhook',
        text: 'Webhook',
        icon: Webhook
    },
    {
        key: 'stats',
        link: '/stats',
        text: 'Resources',
        icon: IconDocuments,
        children: [
            {
                key: 'resources_docs',
                link: 'https://vulners.com/docs/',
                text: 'Documents'
            },
            {
                key: 'resources_blog',
                link: 'https://vulners.com/blog',
                text: 'Blog'
            },
            {
                key: 'resources_glossary',
                link: 'https://vulners.com/glossary',
                text: 'Glossary'
            },
            {
                key: 'faq',
                link: '/faq',
                text: 'FAQ'
            }
        ]
    },
    {
        key: 'plugins',
        link: '/plugins',
        text: 'Plugins',
        icon: IconPlugins
    },
    {
        key: 'pricing',
        link: '/price-list',
        text: 'Pricing',
        icon: IconPrice
    },
    {
        key: 'company',
        link: '/company/contacts',
        text: 'Contacts',
        icon: IconContacts,
        children: [
            {
                key: 'company_contacts',
                link: '/company/about-us',
                text: 'About Us'
            },
            {
                key: 'company_partners',
                link: '/company/partners',
                text: 'Partners'
            },
            {
                key: 'company_branding',
                link: '/company/branding',
                text: 'Branding Guideline'
            }
        ]
    },
    {
        key: 'settings',
        link: '/userinfo',
        text: 'Settings',
        icon: Settings,
        [NEW_FEATURE_DATA_ATTRIBUTE]: 'setting-menu-item',
        divider: 'top'
    }
];

export function getRouteInfoByLink(link: string) {
    link = link.replace(/\/page\/\d+/g, '');
    let done = false;
    const output: { active: string | null; expanded: string[] } = { active: null, expanded: [] };

    const inner = (node: Route, path: string[] = []) => {
        switch (true) {
            case done:
                return;
            case node.pattern?.test(link):
            case node.link === link:
                if (node.virtual) {
                    output.active = path[path.length - 1];
                } else {
                    output.active = node.key;
                }
                output.expanded = [...path, node.key];
                done = true;
                return;
            case Array.isArray(node.children):
                node.children?.forEach((child) => inner(child, [...path, node.key]));
                return;
            default:
                return;
        }
    };

    menuRoutes.forEach((node) => inner(node));
    return output;
}
